import React from "react";

/**
 * Last line of defense against white screens: if a step crashes on
 * unexpected state, show a friendly restart card instead of a blank page.
 * The link is a full page load, so all state is reset cleanly.
 */
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Unhandled error in booking flow:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="bg-white overflow-hidden shadow rounded-lg">
                    <div className="px-4 py-5 sm:p-6 text-center">
                        <h3 className="text-lg font-medium text-gray-900">Något gick fel</h3>
                        <p className="mt-2 text-sm text-gray-500">
                            Sidan kunde inte visas. Börja om bokningen så fungerar det igen.
                        </p>
                        <a
                            href="/"
                            className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
                        >
                            Till startsidan
                        </a>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
